import React from "react";

export function LaptopIcon({ color = "#AD4E00" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50006 14L1.71118 17.5778C1.57234 17.8554 1.50003 18.1616 1.5 18.472V18.9984C1.49992 20.0976 2.3869 20.9908 3.48605 20.9985L3.70006 21H20.2999L20.507 20.9993C21.6089 20.9954 22.5001 20.101 22.5 18.9991V18.472C22.5 18.1616 22.4277 17.8554 22.2889 17.5778L20.5 14V5C20.5 3.89543 19.6046 3 18.5 3H5.5C4.39543 3 3.5 3.89543 3.5 5L3.50006 14Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.125 14.75H20.875" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8 21L8.77208 18.6838C8.90819 18.2754 9.29033 18 9.72076 18H14.2792C14.7097 18 15.0918 18.2754 15.2279 18.6838L16 21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LocationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M10.0327 10H11.7054C12.2794 10 12.7887 10.3673 12.9701 10.912L13.4147 12.2453C13.7027 13.1087 13.0601 14 12.1501 14H3.85006C2.94006 14 2.2974 13.1087 2.5854 12.2453L3.03006 10.912C3.21073 10.3673 3.72073 10 4.29473 10H5.96806"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12C8 12 4 8.80533 4 5.88867C4 3.74133 5.79067 2 8 2C10.2093 2 12 3.74133 12 5.88867C12 8.80533 8 12 8 12Z"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.94289 5.05703C9.46359 5.57773 9.46359 6.42195 8.94289 6.94265C8.42219 7.46335 7.57797 7.46335 7.05727 6.94265C6.53657 6.42195 6.53657 5.57773 7.05727 5.05703C7.57797 4.53633 8.42219 4.53633 8.94289 5.05703"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IpIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M11.1682 13.1689H12.1686" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.99923 10.668L5.66576 13.3357" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3356 7.70727V3.6169C13.3356 2.72256 12.6106 1.99756 11.7163 1.99756H3.6169C2.72256 1.99756 1.99756 2.72256 1.99756 3.6169V9.04849C1.99756 9.94283 2.72256 10.6678 3.6169 10.6678H9.33395"
        stroke="#405261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.66528 13.3359H9.33389" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="9.33398" y="7.6665" width="4.66861" height="7.00292" rx="1.5" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LastActiveIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M10.7109 8.07957H7.60962" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="8.01129" cy="7.67779" r="6.0025" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.6096 8.07965V4.34326" stroke="#405261" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
